module.exports = require("./es-CL");